import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import { AgGridReact } from "@ag-grid-community/react";
import "../MainBox.css";
import "./USBox.css";
import PRHLoader from "../../lib/PRHLoader";

export default function SpecFormUS(props) {
    const [corrList, setCorrList] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [formData, setFormData] = useState({});
    const [formLoading, setFormLoading] = useState(false);
    const [prefRegion, setPrefRegion] = useState(null);

    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        animateRows: true,
        accentedSort: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        suppressRowClickSelection: true,
    }


    const columnDefsUS = [
        {
            headerName: "Prod Order", field: "productionOrder", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 70, sortable: true, sort: "desc"
        },
        {
            headerName: "Binder Name", field: "binderName", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 150
        },
        {
            headerName: "Cover Printer Name", field: "coverPrinterName", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 150
        },
        {
            headerName: "Print #", field: "printingNumber", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 50,
        },
        {
            headerName: "Delivery Date", field: "deliveryDate", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 90
        },
        {
            headerName: "Batch", field: "batch", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 80
        },
        {
            headerName: "Foil", headerClass: "HeaderClassSource header-text-centre", field: "foil",
            cellClass: "CellClassSource ", width: 30
        },
        {
            headerName: "Emboss", headerClass: "HeaderClassSource header-text-centre", field: "emboss",
            cellClass: "CellClassSource ", width: 50
        },
        {
            headerName: "Ordered Qty", field: "orderQuantity", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource  cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
        {
            headerName: "GR Qty", field: "goodsReceiptQty", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource  cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 70
        },
        {
            headerName: "Unit Cost", field: "unitCost", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{Number(params.value).toFixed(2)}</span>
            }, width: 70
        },
        {
            headerName: "Delivered", field: "delivered", headerClass: "HeaderClassSource header-text-centre",
            cellClass: "CellClassSource", width: 70
        },
    ]


    function formatNumberWithCommas(number) {
        if (isNaN(number)) {
            return '';
        }
        // Convert number to string
        let str = number.toString();

        // Split the number into integer and decimal parts
        let parts = str.split(".");

        // Format integer part with commas
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // If decimal part exists and has one digit, add a trailing zero
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }

        // Join integer and decimal parts and return
        return parts.join(".");
    }

    const fetchData = async (id) => {
        try {
            if (id) {
                setFormLoading(true);
                const data = await apiHelper.inventoryPostCall("getCost", { value: id });
                const corrData = await apiHelper.inventoryPostCall("getCorrection", { value: id });
                if (corrData && corrData.length > 0) {
                    setCorrList(corrData.map(item => ({
                        area: item.corrections.split("/")[0],
                        type: item.corrections.split("/")[1],
                        pri: item.corrections.split("/")[2],
                        sts: item.corrections.split("/")[3]
                    })));
                } else { setCorrList([]) }
                if (data != undefined && data != null && data.length > 0) {
                    setRowData(data);
                } else {
                    setRowData([]);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setFormLoading(false);
        }
    }
    const handleRegionChange = async (e) => {
        try {
            const value = e.target.value;
            setPrefRegion(value);
            const res = await apiHelper.inventoryPostCall("setRegion", { ISBN: props.metaData.isbn, Region: value });
            if (res != true) {
                setPrefRegion(null);
            }
        } catch (error) {

            console.error(error, "setting preferred region failed");
        }
    }
    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }
    const columnDefsCorrections = [
        { headerName: "Area", field: "area", headerClass: "HeaderClassSource", cellClass: "CellClassSource addBorder",width:50 },
        { headerName: "Type", field: "type", headerClass: "HeaderClassSource", cellClass: "CellClassSource addBorder", width:50 },
        { headerName: "Pri", field: "pri", headerClass: "HeaderClassSource", cellClass: "CellClassSource addBorder", width: 50 },
        { headerName: "Sts", field: "sts", headerClass: "HeaderClassSource", cellClass: "CellClassSource addBorder", width: 50 }
    ];


    useEffect(() => {


        if (props.metaData) {
            fetchData(props.metaData.isbn);
            setFormData(props.metaData);
            setPrefRegion(props?.metaData?.preffRegion ?? null);
        } else {
            setRowData([]);
            setPrefRegion(null);
        }


    }, [props.metaData]);

    return (<>
        <div className="accordion-content container-fluid specform">
            <Form noValidate="noValidate" >
                {formLoading && <PRHLoader></PRHLoader>}
                <table><tbody>
                    <tr>

                        <td>
                            <table>
                                <tbody>
                                    <tr>

                                        <td>
                                            <div>
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label >Page Count</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input " placeholder="" name="pageCount " value={formData.pageCount != null ? formData.pageCount : ''} disabled />
                                                </Form.Group>
                                            </div>
                                        </td>
                                        <td className="disp-inline">
                                            <div className="marg-10 width200">
                                                <Form.Group controlId="formJobName">
                                                    <Form.Label >Trim Size</Form.Label>
                                                    <input className="custom-input left-p-input " type="jobName" maxLength={100} name="trimSize" value={formData.trimSize || ""} placeholder="" disabled />
                                                </Form.Group>
                                            </div>
                                        </td>
                                            <td>
                                            <div className="width200">
                                                <Form.Group controlId="formJobStatus">
                                                    <Form.Label >Format</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="Format " value={formData.format || ""} disabled />
                                                </Form.Group>
                                            </div>
                                        </td>
                                        <td>

                                            <div className="">
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label title="COST_SHIP_PCT">COS %</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="cos " value={parseFloat(formData.cos).toString() || ""} disabled />
                                                </Form.Group>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label title="Text Stock Weight">Txt Stock Weight</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="textStockBasisWeigh " value={formData.textStockBasisWeight != null ? parseFloat(formData.textStockBasisWeight).toString() : ""} disabled />
                                                </Form.Group>

                                            </div></td>
                                        <td>
                                            <div className="">
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label title="Last Received Prod Order" >Printer</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="lastReceivedOrder" value={formData?.printer || ""} disabled />
                                                </Form.Group>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label title="Latest Network">Coutry of Origin </Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="countryofOrigin " value={formData.countryofOrigin || ""} disabled />
                                                </Form.Group>
                                            </div>
                                        </td>
                                        {/*      <td>
                            {corrList.length > 0 ?
                                <Col md={2} className="mr-0 mt-3">
                                    <div md={2} className="table-box">
                                        <Form.Group controlId="corrections">
                                            <Form.Label>Corrections</Form.Label>
                                            <table className="corr-table">
                                                <thead className="addBorder">
                                                    <th>Area</th>
                                                    <th>Type</th>
                                                    <th>Pri</th>
                                                    <th>Sts</th>
                                                </thead>
                                                <tbody>
                                                    {corrList.map(item => (<tr><td className="addBorder">{item.corrections.split("/")[0]}</td><td className="addBorder">{item.corrections.split("/")[1]}</td><td className="addBorder">{item.corrections.split("/")[2]}</td><td className="addBorder">{item.corrections.split("/")[3]}</td></tr>))}
                                                </tbody>
                                            </table>
                                        </Form.Group>

                                    </div>

                                </Col> :
                                <></>}
                        </td>*/}


                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="width150">
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label >Text Colors</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="textColorsCode " value={formData.texT_COLOR || ""} disabled />
                                                </Form.Group>

                                            </div>
                                        </td>
                                        <td >
                                            <div className="disp-inline">
                                            <div className="marg-10">
                                                <Form.Group controlId="formJobName">
                                                    <Form.Label >Insert</Form.Label>
                                                    <input className="custom-input left-p-input" maxLength={100} name="textInsert" value={formData.insert || ""} placeholder="" required disabled style={{width:"50px"} } />
                                                </Form.Group>
                                            </div>
                                            <div className="marg-10">
                                                <Form.Group controlId="formGroupID">
                                                    <Form.Label >Text Insert Colors</Form.Label>
                                                        <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="textInsertColorsCode " value={formData?.textInsertColors || ""} disabled style={{ width: "100px" }} />
                                                </Form.Group>
                                                </div>
                                                </div>
                                           </td>
                                        <td >
                                            <div className="disp-inline">
                                                <div className="marg-10">
                                                <Form.Group controlId="formJobStatus">
                                                    <Form.Label >Foil/Emboss</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="foil " value={formData.fe || ""} disabled style={{ width: "80px" }} />
                                                </Form.Group>
                                            </div> 
                                            <div className="">
                                                <Form.Group controlId="forFlas">
                                                    <Form.Label >Flaps</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="flaps " value={formData?.flaps || ""} disabled style={{ width: "50px" }} />
                                                </Form.Group>
                                            </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <Form.Group controlId="forFlas">
                                                    <Form.Label >Edge Treatment</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="edgeTreatment" value={formData?.edgeTreatment || ""} disabled />
                                                </Form.Group>
                                            </div> </td>
                                        <td>
                                            <div className="">
                                                <Form.Group controlId="forFlas">
                                                    <Form.Label >Carton Qty</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="cartonQty " value={formData?.cartonQty || ""} disabled />
                                                </Form.Group>
                                            </div> </td>
                                        <td>
                                            <div className="">
                                                <Form.Group controlId="forFlas">
                                                    <Form.Label >Bisac</Form.Label>
                                                    <input id="formGroupID" className="custom-input left-p-input" placeholder="" name="bisaC1 " value={formData?.bisaC1 || ""} disabled />
                                                </Form.Group>
                                            </div> </td>
                                        <td >
                                            <div className="" title="Select if the Region of Origin for the next production order will differ from the current Country of Origin">
                                                <Form.Group >
                                                    <Form.Label >Preferred Region of Origin (optional)</Form.Label>
                                                    <select id="formGroupID" className="custom-input left-p-input" name="Sloc" onChange={handleRegionChange} disabled={!props.isEditable} value={prefRegion ?? ''}>
                                                        <option value='' disabled>{prefRegion}Select Region</option>
                                                        <option value='Domestic' >Domestic (US, CA, MX)</option>
                                                        <option value='Overseas' >Overseas</option>
                                                        <option value='None' >None</option>
                                                    </select>
                                                </Form.Group>
                                                </div>
                                            </td>
                                     
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td>

                            {corrList.length > 0 ? (<td rowSpan="2">

                                <div className="table-box">
                                    <Form.Group controlId="corrections">
                                        <Form.Label>Corrections</Form.Label>
                                        <div className="ag-theme-alpine" style={{ height: "60px", width: "200px", overflow:"hidden" }}>
                                            <AgGridReact
                                                rowData={corrList}
                                                columnDefs={columnDefsCorrections}
                                                domLayout="autoHeight"
                                            />
                                        </div>
                                    </Form.Group>
                                </div>
                            </td>
                            ) : (
                                <td rowSpan="2"></td>
                            )}
                        </td>
                    </tr>
                </tbody></table>
               
               

            </Form>

        </div>
        {rowData && rowData.length > 0 ? <div className="custom" style={{ paddingLeft: "10px", marginBottom: "20px", marginTop: "25px" }}>
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefsUS}
                domLayout="autoHeight"
                gridOptions={gridOptions}
            />
        </div>
            :
            <></>}
    </>)
}